var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44534 5.63377C1.35915 5.72657 1.31986 5.85355 1.33855 5.97882C1.35725 6.10409 1.4319 6.21405 1.54143 6.27765L5.93529 8.82098L10.6617 5.33973L7.18222 10.0691L9.72267 14.4589C9.80472 14.6015 9.96302 14.6825 10.1267 14.6656C10.2904 14.6487 10.4288 14.537 10.4799 14.3806L14.6465 1.87976C14.6955 1.73044 14.6564 1.56621 14.5453 1.45506C14.4341 1.34392 14.2699 1.30478 14.1206 1.35384L1.61969 5.52041C1.55293 5.54285 1.49294 5.58185 1.44534 5.63377Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.4b4d94fd5b8dab7e8ab3116ea3766526.svg";
export { ForwardRef as ReactComponent };